module.exports = __webpack_public_path__ + "img/DK.9783549d.svg";